<template>
    <div>
        <el-col>
            <el-menu
            :unique-opened='true'
            :router="true"
            class="el-menu-vertical-demo"
            background-color="#282B4C"
            text-color="#A5ACB3"
            :default-active="logUrl"
            :collapse="isCollapse"
            :collapse-transition = "false"
            >
                <common-menu :getMenu="getMenu" :isCollapse="isCollapse"></common-menu>
            </el-menu>
        </el-col>
    </div>
</template>
<script>
import CommonMenu from './menu'
import { mapState, mapMutations,mapActions } from "vuex";
export default {
    name:'sidelist',
    props:{
        isCollapse:Boolean,
    },
    data(){
        return{
            getMenu:[],
            currentMenu:'/home',
        }
    },
    components: {
        CommonMenu
    },
    computed:{
        routeList(){
            return this.$store.state.routeList;
        },
        logUrl(){
            return this.$store.state.logUrl;
        }
    },
    methods:{
        ...mapActions([  
            'saveMenu','saveLogUrl'
        ]),
        //获取菜单
        findTreeDatas:function(){
            this.$api.post(this.API.api + 'sysMenu/onLoadSysMenu',{},res=>{
                this.getMenu = res.data; 
                this.saveMenu(this.getMenu);
            })
        },
    },
    created(){
        this.saveMenu(this.getMenu);
        this.findTreeDatas();
    },
}
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 240px;
    min-height: 400px;
  }
</style>




// WEBPACK FOOTER //
// src/components/SideList.vue